import Features from './Features';
import compose from 'recompose/compose';
import withProps from 'recompose/withProps';
import withMediaQueries from '../../hocs/withMediaQueries';
import formatPrismicData from '../../hocs/formatPrismicData';
import { localiseUrl } from 'src/common/utils/format-localised-url';
import withCountry from '../../hocs/withCountry';

const enhance = compose(
  withCountry,
  withMediaQueries,
  formatPrismicData,
  withProps(props => ({
    items: props.items.map(item => ({
      ...item,
      href: localiseUrl(props.country, item.href)
    }))
  }))
);

export default enhance(Features);
